export const StepsEnum = {
  SELECT_SUBSCRIBER: 'SELECT_SUBSCRIBER',
  ERROR: 'ERROR',
  TROUBLESHOOT: 'TROUBLESHOOT',
};

